import { clearString } from "../../services";
export interface Filters {
  state: string;
  reset: () => void;
}

export interface FilterPattern {
  pattern: RegExp;
  setter: { (value: string): void };
}

export interface FilterKeywords {
  keyword: string;
  setter: (value: string) => void;
}

export function OneOf(value: string, options: string[]): string {
  if (!value) return null;
  let target = value.trim().toLocaleLowerCase();
  return options.find((value) => value.toLocaleLowerCase().startsWith(target));
}

export abstract class FiltersModel {
  sortBy: string;
  sortDirection: string;
  pageSize: number;

  setState(input: string): string {
    if (!input) return;

    let mappings: FilterKeywords[] = [
      {
        keyword: "page-size",
        setter: (value) => (this.pageSize = +value),
      },
      {
        keyword: "sort-by",
        setter: (value) => (this.sortBy = this.clean(value)),
      },
      {
        keyword: "order",
        setter: (value) => (this.sortDirection = this.clean(value)),
      },
    ];

    mappings.forEach((mapping) => {
      input = this.testValues(input, mapping);
    });

    return input;
  }

  getState(): string {
    let filters: string[] = [];
    if (this.sortBy) filters.push(`sort-by-${this.encode(this.sortBy)}`);
    if (this.sortDirection) filters.push(`order-${this.sortDirection}`);
    if (this.pageSize) filters.push(`page-size-${Math.max(Math.min(100, this.pageSize), 10)}`);

    return filters.length ? filters.join(" ") : null;
  }

  extract(input: string, filterPattern: FilterPattern): string {
    if (!input) return input;
    // If your regular expression uses the "g" flag, you can use the exec() method multiple times
    // to find successive matches in the same string. When you do so, the search starts at the substring
    // of str specified by the regular expression's lastIndex property (test() will also advance the lastIndex property).
    let match: RegExpExecArray;
    while ((match = filterPattern.pattern.exec(input))) {
      filterPattern.setter(match[1] && match[1].trim());
      if (!filterPattern.pattern.global) {
        break; //since the regular expression is not global then let's run just a simple iteration
      }
    }
    return input.replace(filterPattern.pattern, "").trim();
  }

  private findValue(string: string, keyword: string): { value: string; valueToReplace: string } {
    let value: string = string.replace(`${keyword}-`, "").trim();
    if (!value.includes("-")) {
      return { value: value, valueToReplace: value };
    } else if (value.startsWith(`"`)) {
      value = value.replace(/"/g, "").trim();
      return {
        value: value.slice(0, value.indexOf(`"`)),
        valueToReplace: `"${value.slice(0, value.indexOf(`"`))}"`,
      };
    }
    return {
      value: value.slice(0, value.indexOf(" ")),
      valueToReplace: value.slice(0, value.indexOf(" ")),
    };
  }

  testValues(input: string, filterPattern: FilterKeywords): string {
    if (filterPattern.keyword === "id") {
      filterPattern.setter(input);
    }

    if (!input || input.indexOf(filterPattern.keyword) === -1) return input;

    const matchWithLeftover = input.slice(input.indexOf(filterPattern.keyword));
    const { value, valueToReplace } = this.findValue(matchWithLeftover, filterPattern.keyword);

    console.log({
      key: filterPattern.keyword,
      index: input.indexOf(filterPattern.keyword),
      withLeftover: matchWithLeftover,
      value,
    });

    if (value.length > 0) {
      filterPattern.setter(value);
      return input.replace(`${filterPattern.keyword}-${valueToReplace}`, "").trim();
    }
  }

  clean(value: string): string {
    return clearString(value);
  }

  yesOrNo(value: string): string {
    let cleanValue = this.clean(value);
    return !cleanValue || cleanValue.charAt(0).toUpperCase() == "Y" ? "Yes" : "No";
  }

  encode(value: string) {
    let cleanValue = value.trim();
    return cleanValue.indexOf(" ") !== -1 ? `"${cleanValue}"` : cleanValue;
  }

  abstract serializeFrom(stateBug: {}): void;
  abstract serializeTo(stateBug: {}): void;
}
